var $ = require('jquery')
$(function () {
  const chartElement = document.getElementById('js-contracted-construction-price-range-chart')

  if (chartElement === null) {
    return
  }

  const { labels, values, colors } = JSON.parse(chartElement.dataset.chart)

  // labelを加工
  const formattedLabels = labels.map((label) => {
    return {
      '0万円~50万円': '~50万円',
      '50万円~100万円': '~100万円',
      '100万円~150万円': '~150万円',
      '150万円~200万円': '~200万円',
      '200万円~250万円': '~250万円'
    }[label] || label
  })

  new Chart(chartElement, {
    type: 'bar',
    data: {
      labels: formattedLabels,
      datasets: [{
        label: '件数',
        data: values,
        backgroundColor: colors
      }]
    },
    options: {
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          display: true,
          stacked: false,
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
      legend: {
        display: false
      },
      title: {
        display: false
      },
      plugins: {
        labels: {
          render: 'label',
          fontSize: 0
        }
      },
      animation: {
        duration: 0
      }
    }
  })
})
